var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnItAllLeaderStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9653_7896)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    width: 64,
    height: 12,
    fill: "#A8AEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: 12,
    width: 40,
    height: 12,
    fill: "#2B3395"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 40,
    height: 12,
    fill: "#1E243D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9653_7896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnItAllLeaderStack);
export default __webpack_public_path__ + "static/media/learn-it-all-leader-stack.983d3989b712bd72f588f3497a1afb15.svg";
export { ForwardRef as ReactComponent };